import SlideApi from '@/api/slide'
import Socket from '@/socket'

const patchSlideByIdAction = ({ commit, state }, slide) => {
  const { id: slideId } = slide

  if (slideId === state.activeSlideId) {
    commit('updateSlideActive', slide)
    return
  }

  const { slides } = state.presentation

  const newSlides = slides.map((item) => {
    if (item.id !== slideId) return item

    return { ...item, ...slide }
  })

  commit('setSlides', newSlides)
}

const updateSlidesVersionAction = ({ commit, state }, { newSlideVersions }) => {
  if (!newSlideVersions || !newSlideVersions.length) return
  newSlideVersions.forEach((slide) => {
    if (state.activeSlideId == slide.id) {
      commit('updateSlideActive', {
        id: slide.id,
        version: slide.version,
      })
    }
    commit('updateSlideById', {
      id: slide.id,
      version: slide.version,
    })
  })
}

const updateSlideActiveActionV2 = async ({ commit, state }, { slide, $optimistic = true }) => {
  const slideId = slide.id || state.slideActive.id
  if (!slideId) return
  if ($optimistic) {
    commit('updateSlideActive', slide)
  }

  await SlideApi.updateSlideById(slideId, slide)
  commit('updateSlideActive', slide)
}

// action này dùng để fix việc có order trong 1 slide bị sét về null hoặc 0 làm cho người dùng ko thể sắp xếp đc thứ tự slides
// thì sẽ check nếu có null hoặc 0 thì sẽ đánh lại orders theo danh sách hiển thị trên màn hình hiện tại khi người dùng mở presentation editor
const recheckAndFixCorrectOrderSlidesAction = async ({ commit, state, dispatch }) => {
  const { slides } = state.presentation
  const isCheckOrderNotSet = slides.some((item) => !item.order)
  if (!isCheckOrderNotSet) return
  slides.forEach((item, key) => {
    item.order = key + 1
  })
  const slideSorted = slides.map((item) => {
    return { id: item.id, order: item.order }
  })
  dispatch('updatePresentationAction', {
    slides,
    Slides: slides,
  })
  const indexSlideActive = slides.findIndex((item) => item.id === state.slideActive.id)
  if (indexSlideActive !== -1) {
    commit('updateSlideActive', {
      order: slides[indexSlideActive].order,
    })
  }
  const payload = {
    sort: slideSorted,
    accessCode: state.presentation.uniqueAccessCode,
    socketId: Socket.getSocketId(),
  }
  await SlideApi.sortSlides(state.presentation.id, payload)
}

export default {
  patchSlideByIdAction,
  updateSlidesVersionAction,
  updateSlideActiveActionV2,
  recheckAndFixCorrectOrderSlidesAction,
}
